import { Helmet } from 'react-helmet-async';

const BASE_URL = 'https://lrsrevenue.com';

// Page-specific OG images
const OG_IMAGES = {
  home: 'https://lrsrevenue.com/og-dan-leitner.jpg?v=2',
  talent: 'https://static.prod-images.emergentagent.com/jobs/4583afc9-4ede-439a-96b1-886646eeac82/images/ea5da443d97184eb2313e92313eee004771319ad9f2be4d6a60207a9f9f9ccfe.jpeg',
  insights: 'https://static.prod-images.emergentagent.com/jobs/4583afc9-4ede-439a-96b1-886646eeac82/images/cddde1840e64c672d0684fc310fd62fc60b0e67a8b2220a6392072537609995e.jpeg',
  services: 'https://static.prod-images.emergentagent.com/jobs/4583afc9-4ede-439a-96b1-886646eeac82/images/278448c0d4414db8078a3621a592bb13cadfc8ae36143c443a8ce7590df72bf3.jpeg',
  resources: 'https://static.prod-images.emergentagent.com/jobs/4583afc9-4ede-439a-96b1-886646eeac82/images/3e6ad13ae12097d7965f397d0ab46a04fc9170df4b1aa97177725b12a69920be.jpeg',
};

/**
 * SEO Component - Manages page-specific meta tags for social sharing
 * 
 * @param {string} title - Page title
 * @param {string} description - Page description (max ~155 chars recommended)
 * @param {string} path - URL path (e.g., '/talent', '/insights')
 * @param {string} image - Image key from OG_IMAGES or custom URL
 * @param {string} type - Open Graph type (default: 'website')
 */
const SEO = ({ 
  title = 'Dan Leitner | Sales Development & GTM Leader',
  description = 'Sales development leader who builds SDR organizations that create pipeline, develop future AEs, and scale.',
  path = '',
  image = 'home',
  type = 'website'
}) => {
  const fullUrl = `${BASE_URL}${path}`;
  const imageUrl = OG_IMAGES[image] || image;
  const fullTitle = title.includes('Leitner') ? title : `${title} | Leitner Revenue Systems`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:image:width" content={image === 'home' ? '1200' : '1264'} />
      <meta property="og:image:height" content={image === 'home' ? '630' : '848'} />
      <meta property="og:site_name" content="Leitner Revenue Systems" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={fullUrl} />
    </Helmet>
  );
};

export { SEO, OG_IMAGES };
export default SEO;
